module.exports = __webpack_public_path__ + "static/media/breakfast-brunch-mobile-411x93@2x.faee1dfb.jpg";